export enum ReplenishTaskProgressEnum {
  UNFULFILLED = 'unfulfilled',
  PARTIALLY_FULFILLED = 'partially-fulfilled',
  FULFILLED = 'fulfilled',
}
